import type { ITimestamp } from '../../types/common';

export const sbomRuleTypeValues = ['sbom_file'] as const;
export type SBOMRuleType = typeof sbomRuleTypeValues[number];
export enum CycloneDXVersion {
  DENIED = 'denied',
  V_1_2 = '1.2',
  V_1_3 = '1.3',
  V_1_4 = '1.4',
  V_1_5 = '1.5',
  V_1_6 = '1.6',
}

export enum SPDXVersion {
  DENIED = 'denied',
  V_2_2 = '2.2',
  V_2_3 = '2.3',
}

export type SBOMRule = ITimestamp & {
  ruleId: number;
  type: SBOMRuleType;
  minCycloneDXVersion: CycloneDXVersion;
  minSPDXVersion: SPDXVersion;
  author: boolean;
  creationTimestamp: boolean;
  componentSupplier: boolean;
  componentPurl: boolean;
  componentCPE: boolean;
  componentGenericPurl: boolean;
  cycloneDXRelationships: boolean;
  cycloneDXVulnerabilities: boolean;
  spdxRelationships: boolean;
};
